<div>
  <mat-label>{{title}}</mat-label>
</div><br>
<form #form="ngForm">
  <mat-form-field class="input-margin">
    <mat-label>
      銘柄
    </mat-label>
    <input matInput required placeholder="銘柄"
           name="meigara" [(ngModel)]="meisai.feedShubetsu">
  </mat-form-field>
<!--  <mat-form-field class="input-margin">-->
<!--    <mat-label>-->
<!--      切り替え目安日齢-->
<!--    </mat-label>-->
<!--    <input matInput required placeholder="切り替え目安日齢" type="number" min="1"-->
<!--           name="kirikaeNichirei" [(ngModel)]="meisai.kirikaeNichirei">-->
<!--  </mat-form-field>-->
  <mat-form-field class="input-margin">
    <mat-label>
      cp
    </mat-label>
    <input matInput required placeholder="cp" type="number" min="0"
           name="cp" [(ngModel)]="meisai.cp">
  </mat-form-field>
  <mat-form-field class="input-margin">
    <mat-label>
      ME
    </mat-label>
    <input matInput required placeholder="ME" type="number" min="0"
           name="ME" [(ngModel)]="meisai.ME">
  </mat-form-field>
</form>
<div mat-dialog-actions align="end"
     [matTooltip]="commonService.getAlertTooltipMessage(form)"
     matTooltipPosition="right"
     style="width: fit-content">
  <button mat-button mat-flat-button color="primary" (click)="commonService.onClick(this.matDialogRef, meisai)" [disabled]="form.invalid || !form.dirty">
    <span>Enter</span>
  </button>
</div>
